export const ToastTypeEnum = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warn",
    ERROR: "error"
};